<div class="list-container">
    <div
    data-cy="title-suggestion"
        *ngFor="let title of titleList"
        class="title"
        (click)="selectTile(title)"
    >
        {{ title }}
    </div>
</div>
